export default __webpack_public_path__ + "static/home-sustainability-55e4a2e20006c0759cd360d532cf6bea.jpg";